angular.module('app')
  .filter('mongoDate', function () {
    return (input) => (input && input['$date'] && input['$date']['$numberLong'] ? input['$date']['$numberLong'] : null);
  });
